import { defineMessages } from 'react-intl'

export default defineMessages({

  'firstName': {
    id: 'auth.signup.first_name',
    defaultMessage: 'First name',
  },

  'lastName': {
    id: 'auth.signup.last_name',
    defaultMessage: 'Last name',
  },

  'email': {
    id: 'auth.signup.email',
    defaultMessage: 'Email',
  },

  'password': {
    id: 'auth.signup.password',
    defaultMessage: 'Password',
  },

  'birthdate': {
    id: 'auth.signup.birthdate',
    defaultMessage: 'Date of birth',
  },

  'male': {
    id: 'auth.signup.male',
    defaultMessage: 'Male',
  },

  'female': {
    id: 'auth.signup.female',
    defaultMessage: 'Female',
  },

  'gender': {
    id: 'auth.signup.gender',
    defaultMessage: 'Gender',
  },

  'country': {
    id: 'auth.signup.country',
    defaultMessage: 'Country',
  },

  'terms': {
    id: 'auth.signup.terms',
    defaultMessage: 'Terms',
  },

})
